export default __webpack_public_path__ + "static/media/nobel-pic-1.299631ef.png";